import * as React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useAppSelector } from '../store';
import { Link } from 'react-router-dom';


const Update = () => {

    // bearer token from store
    const bearerToken = useAppSelector(state => state.bearerToken.value);

    // state variables
    const [surveyId, setSurveyId] = React.useState("");
    const [csvFile, setCSVFile] = React.useState<File | string>("");
    const [csvFileName, setCSVFileName] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [isError, setIsError] = React.useState(false);
    
    // if update embedded data button is clicked, update embedded data
    const updateEmbeddedData = async () => {
        try {
            setMessage("");
            if (surveyId === "" || !surveyId.startsWith("SV_") || csvFile === "" || csvFileName === "" ) {
                setMessage("Enter valid survey id and choose csv file");
                await setIsError(true);
                return;
            }
            await setIsError(false);
            const formData = new FormData();
            formData.append("formFile", csvFile);
            formData.append("fileName", csvFileName);

            let embeddedDataResponse = await axios.put(`api/update/${surveyId}`, formData,
                { headers: { 'token': bearerToken } });
            console.log(embeddedDataResponse);
            if (embeddedDataResponse.data.startsWith("Error")) {
                await setIsError(true);
            }
            setMessage(embeddedDataResponse.data);

        } catch (error) {
            await setIsError(true);;
            setMessage((error as Error).message);
            console.log(error);
        }
    };

    const onCSVFileClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
        const element = event.target as HTMLInputElement;
        element.value = '';
        setMessage("");
        setCSVFile("");
        setCSVFileName("");
    }

    // set survey id from form
    const handleSurveyIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSurveyId(event.target.value);
    }

    // set file and file name from form
    const handleCSVFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files != null && event.target.files.length != 0) {
            console.log(event.target.files[0]);
            setCSVFile(event.target.files[0]);
            setCSVFileName(event.target.files[0].name);
        }
    }

    return (
        <div>
            {bearerToken 
            ? <div>
                <h1>Update Embedded Data of Responses in a Survey</h1>
                <p>Upload a .csv file with 3 columns (in this order): Response ID, Data Field, and Data Value</p>
                <p>Column names are optional for the .csv file</p>
                <p>Example: a row reading "R_abcdefg,State,Utah" will update the embedded data field "State" to have a value of "Utah"
                    for the response with id "R_abcdefg"</p>
                
                <input type="text" autoComplete="on" placeholder="Enter Survey ID" value={surveyId} onChange={handleSurveyIdChange} />
                <input id="embeddedDataFile" type="file" accept=".csv" onChange={handleCSVFileChange} onClick={onCSVFileClick}/>
                <button id="updateEmbeddedDataButton" onClick={updateEmbeddedData} >Update Embedded Data</button>

                {isError
                    ? <p className="errorMessage">{message}</p>
                    : <p className="successMessage">{message}</p>
                }
            </div>

                : <p>Go to the <Link to="/">Home</Link> tab to login</p>
            }
            

        </div>
    )
};

export default connect()(Update);
